import { ArrowLeft } from 'lucide-react';
import { ServiceProviderForm } from './ServiceProviderForm';
import { useNavigate } from '../../hooks/useNavigate';

interface EditServiceProviderPageProps {
  providerId: string;
}

export function EditServiceProviderPage({ providerId }: EditServiceProviderPageProps) {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('service-providers');
  };

  const handleCancel = () => {
    navigate('service-providers');
  };

  return (
    <div className="min-h-screen bg-slate-100 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={handleCancel}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors mb-4"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Service Providers
          </button>
          <h1 className="text-3xl font-bold text-slate-900">Edit Service Provider</h1>
          <p className="text-slate-600 mt-1">Update provider information</p>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <ServiceProviderForm
            providerId={providerId}
            onClose={handleCancel}
            onSuccess={handleSuccess}
            isModal={false}
          />
        </div>
      </div>
    </div>
  );
}
